import { useState } from "react";

import { Lightbulb, X } from "lucide-react";

import { GuideDetailModal } from "./GuideModal";
import { useGuideState } from "./guideStorage";

import type { ReactNode } from "react";

export { GuideList } from "./GuideList";

/**
 * A one-line tip for teachers. `details` opens in a dialog on the same page;
 * closing the tip hides it for good on this browser.
 */
export const GuideCard = ({
  id,
  title,
  children,
  userId,
  dismissible = true,
  details,
  ordered = false,
}: {
  id: string;
  title: string;
  children: ReactNode;
  userId: string;
  dismissible?: boolean;
  details?: string[];
  ordered?: boolean;
}) => {
  const { state, dismissCard } = useGuideState(userId);
  const [open, setOpen] = useState(false);
  if (dismissible && state.dismissedCards.includes(id)) {
    return null;
  }
  return (
    <aside
      className="canvaschool-guide-card canvaschool-no-print"
      role="note"
      aria-label={title}
    >
      <Lightbulb size={18} aria-hidden="true" />
      <div className="canvaschool-guide-card-body">
        <strong className="canvaschool-guide-card-title">{title}</strong>
        {details ? <span> {children}</span> : children}
        {details && details.length > 0 && (
          <>
            {" "}
            <button
              type="button"
              className="canvaschool-link-button"
              onClick={() => setOpen(true)}
            >
              자세히 보기
              <span className="canvaschool-visually-hidden">: {title}</span>
            </button>
          </>
        )}
      </div>
      {dismissible && (
        <button
          type="button"
          className="canvaschool-icon-btn"
          aria-label={`${title} 안내 닫기`}
          onClick={() => dismissCard(id)}
        >
          <X size={18} aria-hidden="true" />
        </button>
      )}
      {open && details && (
        <GuideDetailModal
          title={title}
          items={details}
          ordered={ordered}
          onClose={() => setOpen(false)}
        />
      )}
    </aside>
  );
};
